module.exports = __webpack_public_path__ + "img/logo-ois.f0ed7ced.png";